import { createBrowserRouter } from 'react-router';

import { routes } from './route-tree';

export const router = createBrowserRouter(routes);
